<template>
  <div>
    <!-- <app-overlay-loader v-if="preloader" /> -->
    <div class="row">
      <div class="col-12">
        <div class="text-right mr-5" v-if="siteAdd == true">
          <el-tooltip
          placement="top"
          :effect="themeMode.darkMode == true ? 'light' : 'dark'"
          :content="$t('add_site_detail')">
            <button
              type="button"
              class="btn btn-primary btn-with-shadow"
              @click="addSite">
              {{ $t("add_site") }}
            </button>
          </el-tooltip>
        </div>
      </div>
      <div class="col-12">
        <div class="vertical-tab">
          <div class="row">
            <div class="col-md-3 pr-md-3 tab-menu">
              <div class="card card-with-shadow border-0">
                <div class="header-icon">
                  <div class="icon-position d-flex justify-content-center">
                    <div
                      class="
                        tab-icon
                        d-flex
                        justify-content-center
                        align-items-center
                      "
                    >
                      <app-icon name="link" />
                    </div>
                  </div>
                </div>
                <div class="px-primary py-primary">
                  <div
                    class="nav flex-column nav-pills"
                    role="tablist"
                    aria-orientation="vertical"
                  >
                    <app-overlay-loader v-if="preloader" />
                    <p class="text-center" v-if="sites.length == 0">
                      This job no site
                    </p>
                    <div v-for="(site, index) in sites" :key="index">
                      <a
                        v-if="site.type == 0"
                        style="
                          border-bottom: 0px;
                          border-color: transparent;
                          cursor: pointer;
                        "
                        class="
                          activeclass
                          text-capitalize
                          tab-item-link
                          d-flex
                          justify-content-between
                          my-2 my-sm-3
                        "
                        data-toggle="pill"
                        @click.prevent="siteList(site.id)"
                      >
                        <span>{{ site.title }} <i v-if="newSite == site.id" class="fa fa-check-circle text-success"></i></span>
                        <span class="active-icon"
                          ><app-icon name="chevron-right"
                        /></span>
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="col-md-9 pl-md-3">
              <site-create
                v-if="isSiteCreate"
                :getJob="getJob"
                :siteid="id"
                :siteType="0"
                :jobid="job_id"
              />

              <site-list
                v-if="isSiteList"
                :id="siteId"
                :getJob="getJob"
                :siteid="id"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { COMPANY_JOB_SHOW } from "../../../../../../Config/ApiUrl.js";
import { axiosGet, axiosPost } from "../../../../../../Helpers/AxiosHelper.js";
// import CopyButton from "../../../Demo/UI/CopyButton.vue";

export default {
  name: "Site",
  //   components: { CopyButton },
  data() {
    return {
      newSite: 0,
      preloader: true,
      isSiteCreate: false,
      isSiteList: true,
      siteAdd: true,
      //   siteList:false,
      siteId: 0,
      sites: {},
      id: "",
      job_id: 0,
    };
  },
  methods: {
  
    siteList(id) {
      this.siteId = id;
      this.isSiteCreate = false;
      this.isSiteList = true;
      this.siteAdd = true;
      localStorage.setItem('siteId',0);
      $('.activeclass').removeClass('active');
      $(this).addClass('active');
      // this.siteList = false;
    },
    addSite() {
      this.isSiteCreate = true;
      this.isSiteList = false;
      this.siteAdd = false;
      
      // this.siteList = true;
    },
    getJob(id) {
      // let id = this.$attrs['props'].id;
      axiosGet(COMPANY_JOB_SHOW + "/" + id)
        .then((res) => {
          this.job = res.data;
          this.sites = this.job.sites;
          this.preloader = true;
          // let id = this.job.sites[0].id;

          let d = this.job.sites.filter((e, i) => {
            let a = e.type == 0;
            return a;
          });
          let id = d;
          if (this.sites.length > 0) {
            this.siteId = id[0].id;
          }
          this.newSite = localStorage.getItem('siteId');
        })
        .catch((error) => {
          
        })
        .finally(() => {
          this.preloader = false;
          $('.activeclass:first').addClass('active');
        });
    },
  },
  mounted() {
    // let myLocation = location.href;
    // let split = myLocation.split("/");
    // let nsplit = split[6].split("?");
    // this.id = nsplit[0];
    // this.getJob(nsplit[0]);
    let id = this.$attrs['props'].id;
    this.job_id = id;
    this.getJob(id);
    this.sitesreload = true;
  },
   computed: {
    themeMode() {
      return this.$store.state.theme;
    },
  },
  watch: {
    // whenever question changes, this function will run
    sites: function (newsites, oldsites) {
      // 
      // this.getJob(id);
    },
  },
};
</script>
